import React from 'react';
import * as styles from './separator.css';

const Separator = () => (
    <hr className={styles.separator} />
);

export default Separator;
